import React from 'react'
import i18n from '@intelie/live/dist/services/i18n'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import * as S from './styled'

interface Props {
    favorited?: boolean
    onImport?: () => void
    onExport?: () => void
    lastSaved?: string
    style?: React.CSSProperties
}

const FileActions: React.FC<Props> = ({ favorited, onImport, onExport, lastSaved, style }) => {
    return (
        <S.Container style={style}>
            {/* {favorited ? (
                <S.Space>
                    <i className="far fa-star" />
                </S.Space>
            ) : null} */}
            {onImport ? (
                <>
                    <S.Space onClick={onImport}>
                        <b>{i18n('Import')}</b>
                        <i  className="far fa-file-upload" />
                    </S.Space>
                    {onExport || lastSaved ? (<S.Delimiter />) : null}
                </>
            ) : null}
            {onExport ? (
                <>
                    <S.Space onClick={onExport}>
                        <b>{i18n('Export')}</b>
                        <i  className="far fa-file-download" />
                    </S.Space>
                    <S.Delimiter />
                </>
            ) : null}
            {lastSaved ? ( 
                <S.Space>
                    <b>{i18n('Last Saved:')}</b>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-history`}>{i18n('Version History')}</Tooltip>}
                    >
                        <span>{lastSaved}</span>
                    </OverlayTrigger>

                    <i className="far fa-history" />
                </S.Space>
            ) : null}
        </S.Container>
    )
}

export default FileActions
